import useRole from '~/store/user/hooks/useRole';

import useGetDuplicateClientAllocationsForActTeamMember from './useGetDuplicateClientAllocationsForActTeamMember';
import useGetDuplicateClientAllocationsForGlobalUser from './useGetDuplicateClientAllocationsForGlobalUser';
import useGetDuplicateClientAllocationsForTeamAdmin from './useGetDuplicateClientAllocationsForTeamAdmin';
import {
  IUseGetEditClientAllocationsParams,
  IUseGetDuplicateAllocationResult,
} from '../../EditClientAllocation/hooks/types';

const useGetDuplicateClientAllocations = (
  params: IUseGetEditClientAllocationsParams,
): IUseGetDuplicateAllocationResult => {
  const { isGlobalUser, isActTeamMember } = useRole();
  // LocalAdmin and other roles
  const isTeamAdmin = !isGlobalUser && !isActTeamMember;

  const globalUserResult = useGetDuplicateClientAllocationsForGlobalUser({
    ...params,
    enabled: params.enabled ?? isGlobalUser,
  });

  const actTeamMemberResult = useGetDuplicateClientAllocationsForActTeamMember({
    ...params,
    enabled: params.enabled ?? isActTeamMember,
  });

  const teamAdminResult = useGetDuplicateClientAllocationsForTeamAdmin({
    ...params,
    enabled: params.enabled ?? isTeamAdmin,
  });

  if (isGlobalUser) {
    return globalUserResult;
  }

  if (isActTeamMember) {
    return actTeamMemberResult;
  }

  return teamAdminResult;
};

export default useGetDuplicateClientAllocations;
